export const GET_REPORT_SUBMITTED_TIME = "GET_REPORT_SUBMITTED_TIME"
export const GET_REPORT_SUBMITTED_TIME_SUCCESS =
  "GET_REPORT_SUBMITTED_TIME_SUCCESS"
export const GET_REPORT_SUBMITTED_TIME_ERROR = "GET_REPORT_SUBMITTED_TIME_ERROR"
